import React, { FC, useMemo } from 'react';
import clsx from 'clsx';
import { Typography, Icon } from '@npm-registry/eapteka-ui';
import { IconNameMedium } from '@npm-registry/eapteka-ui/lib/components/Icon/icons';
import { Tooltip } from '../../core/Tooltip';
import { formatIcon } from '../../../helpers/formatIcon';
import { DeliveryProps } from './types';
import styles from './Delivery.scss';

export const Delivery: FC<DeliveryProps> = ({
  className,
  tooltip,
  text,
  textColor,
  icon,
  iconColor
}) => {
  const iconStyles = useMemo(
    () => ({ fill: iconColor }),
    [iconColor]
  );
  const textStyles = useMemo(
    () => ({ color: textColor }),
    [textColor]
  );
  const iconName = useMemo(
    () => formatIcon(icon) || (tooltip ? 'question' : ''),
    [icon, tooltip]
  ) as IconNameMedium;

  return (
    <div className={clsx([styles.root, className])}>
      <Tooltip
        className={styles.tooltip}
        content={tooltip}
        style={iconStyles}
        iconName={iconName}
      >
        {iconName ? (
          <span className={styles.container}>
            <Icon
              size="s"
              className={styles.icon}
              name={iconName}
              style={iconStyles}
            />
          </span>
        ) : null}
      </Tooltip>
      <Typography
        className={styles.text}
        variant="p2"
        style={textStyles}
      >
        {text}
      </Typography>
    </div>
  );
};
